// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","overlay":"ModalOverlay_overlay__Y7D2g"};